import React, { useEffect, useState } from 'react';
import './PaginatedCards.css';
import Flashcard from "../Flashcard/Flashcard";
import {HOST} from "../config";
import MultipleChoice from "../MultipleChoice/MultipleChoice";
import TaskCard from "../TaskCard/TaskCard";
const limit = 20; // number of cards per page

const PaginatedCards = ({ setId }) => {
    const [cards, setCards] = useState([]);
    const [page, setPage] = useState(1);
    const [totalCards, setTotalCards] = useState(0);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchCards = (currentPage) => {
            setLoading(true);
            fetch(HOST + `/api/sets/${setId}/cards?page=${currentPage}&limit=${limit}`)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Error fetching cards.');
                    }
                    return response.json();
                })
                .then(data => {
                    // Expecting an object: { cards: [...], total: number }
                    setCards(data.cards);
                    setTotalCards(data.total);
                    setLoading(false);
                })
                .catch(err => {
                    console.error(err);
                    setLoading(false);
                });
        };

        fetchCards(page);
    }, [setId, page]);

    const totalPages = Math.ceil(totalCards / limit);

    return (
        <div className="paginated-cards">
            <h2>Cards</h2>
            {loading ? (
                <p>Loading cards...</p>
            ) : (
                <ul>
                    {cards && cards.map(card => (
                        <li key={card.id} className="card-item">
                            {card.type === "flashcard" && (<Flashcard card={card} interactive={false} bookmarked={false} />)}
                            {(card.type === "multipleChoice" || card.type === "singleChoice") && (<MultipleChoice card={card} interactive={false} bookmarked={false} />)}
                            {card.type === "task" && (<TaskCard card={card} interactive={false} />)}
                        </li>
                    ))}
                </ul>
            )}
            <div className="pagination-controls">
                <button disabled={page <= 1} onClick={() => setPage(page - 1)}>
                    Prev
                </button>
                <span>
          Page {page} of {totalPages || 1}
        </span>
                <button disabled={page >= totalPages} onClick={() => setPage(page + 1)}>
                    Next
                </button>
            </div>
        </div>
    );
};

export default PaginatedCards;
